import React from "react";
import {userService} from "../jwt/_services";
import {employeeService} from "../jwt/_services/hr/employeeService";

export const userProvider = {
    getOptions,
    getItem,
    getAllUserWithoutEmployee,
    listAllUserExcludeCurrentLogin,
};

async function getOptions(){
    try {
        const listItems = await userService.getAll();

        return listItems.map((itemData) => {
            const { id, username } = itemData
            return (
                {
                    id: id,
                    value: username,
                    label: <div><label>{username}</label></div>}
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getAllUserWithoutEmployee(){
    try {
        const listItems = await employeeService.getAllUserWithoutEmployee();

        return listItems.map((itemData) => {
            const { id, username } = itemData
            return (
                {
                    id: id,
                    value: username,
                    label: <div><label>{username}</label></div>}
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function listAllUserExcludeCurrentLogin(){
    try {
        const listItems = await userService.listAllUserExcludeCurrentLogin();

        return listItems.map((itemData) => {
            const { id, username } = itemData
            return (
                {
                    id: id,
                    value: username,
                    label: <div><label>{username}</label></div>}
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await userService.getItem(id);

        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}